import React, { useState } from 'react';
import { subscribeNewsletter } from '../utils/firebaseService';

const Logo = () => (
  <svg 
    id="Layer_1" 
    data-name="Layer 1" 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 768 241.09" 
    className="h-[50px] md:h-[62px] xl:h-[75px] w-auto object-contain"
    style={{ overflow: 'visible' }}
  >
    <defs>
      <style>{`
        .logo-txt-1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: 52.67px;
          fill: currentColor;
          letter-spacing: 0.1em;
        }
        .logo-txt-2 {
          font-family: 'Louis George Cafe', sans-serif;
          font-size: 25px;
          font-weight: 500;
          fill: currentColor;
          opacity: 0.9;
          letter-spacing: 0.28em;
        }
        .logo-path {
          fill: currentColor;
        }
        .logo-line {
          fill: none;
          stroke: currentColor;
          stroke-miterlimit: 10;
        }
      `}</style>
    </defs>
    <g id="xzLYyD">
      <path className="logo-path" d="m391.52,18.42c1.98-2.15,4.48-3.02,7.29-3.03,1.4,0,2.68.68,3.99,1.18,1.72.65,3.03,1.89,4.39,3.05.27.23.28.46.08.77-1.98,3.09-4.78,4.91-8.4,5.38-1.76.23-3.47-.15-5.02-1.06-1.64-.97-1.67-.97-1.68.89-.02,3.03-.36,6.03-.9,9-.45,2.45-1.47,4.71-2.39,7.01-1.02,2.55-2.34,4.98-3.09,7.63-.55,1.93-1.17,3.84-1.54,5.82-.04.22-.08.44-.02.66.08.31.24.41.53.2,3.11-2.2,6.28-1.52,9.39-.09,1.65.76,3.2,1.72,4.48,3.06.24.25.34.36.09.69-1.95,2.67-4.57,4.32-7.78,4.91-2.28.42-4.46.1-6.24-1.62-.16-.16-.3-.49-.58-.35-.28.13-.1.44-.1.67-.03,1.16.51,2.19.83,3.26,1.18,3.85,3.29,7.18,5.89,10.21.35.41.26.66-.08.89-2.79,1.89-5.74,3.28-9.23,2.66-1.1-.2-2.19-.65-3.1-1.3-1.5-1.07-2.92-2.26-3.76-3.97-.24-.48-.45-.23-.63.03-.54.81-1.26,1.44-1.93,2.12-1.51,1.54-3.4,2.46-5.44,2.95-1.7.41-3.5.46-5.21-.24-1.27-.52-2.56-1.01-3.68-1.83-.83-.61-.85-.73-.18-1.49,1.34-1.54,2.64-3.11,3.92-4.7,1.13-1.41,1.72-3.02,2.21-4.69.4-1.36.85-2.71,1.03-4.13.03-.26.19-.6-.06-.76-.27-.18-.46.19-.69.29-.02,0-.04.03-.06.04-2.29,2.34-5.04,2.2-7.88,1.43-2.56-.69-4.57-2.21-6.17-4.3-.37-.48-.29-.8.1-1.2,1.4-1.44,3.14-2.34,4.92-3.18,1.4-.66,2.88-.92,4.42-.92,1.56,0,3,.37,4.25,1.36.18.14.37.42.63.24.26-.18.18-.5.12-.75-.88-3.72-1.81-7.41-3.19-11-1.16-3.01-2.17-6.09-2.88-9.26-.73-3.27-.88-6.56-.83-9.88,0-.12.02-.25,0-.37-.05-.25.15-.6-.15-.73-.24-.11-.43.17-.64.29-3.99,2.41-8.13,1.76-11.89-.99-1.02-.75-1.84-1.69-2.58-2.71-.23-.32-.22-.46.02-.72,1.34-1.48,2.97-2.54,4.79-3.33,1.38-.6,2.77-1.2,4.28-1.2,2.49,0,4.73.73,6.45,2.63.49.53.6.14.69-.22.53-1.98,1.28-3.87,2.23-5.68,2.32-4.42,5.07-8.45,9.74-10.72,1.33-.65,2.72-1.12,4.19-1.31,1.13-.14,2.19.29,3.21.64,2.17.76,3.9,2.2,5.5,3.85,2.1,2.17,3.87,4.59,5.4,7.17,1.1,1.85,1.99,3.83,2.59,5.92.08.29.14.61.32.81Zm-2.31,15.08c.02-.22-.11-.3-.22-.4-.31-.27-.64-.53-.95-.82-4.01-3.78-7.99-7.59-12.02-11.34-1.49-1.39-1.06-1.47-2.71,0-2.04,1.84-4.01,3.78-6.07,5.6-2.37,2.11-4.56,4.41-7.03,6.41-.42.34-.47.62-.05,1.01.49.45.91.98,1.41,1.4,4.21,3.55,8.09,7.47,12.32,11.01.61.51.92.39,1.45-.04,2.41-1.95,4.54-4.21,6.91-6.2,2.38-1.99,4.38-4.39,6.74-6.4.09-.08.16-.18.21-.24Zm-22.89,25.4c.07.64,0,1.23.09,1.82.17,1.07.57,2.08.84,3.12.97,3.72,2.97,6.54,6.66,7.95.32.12.6.15.91,0,3.05-1.45,5.08-3.78,6.03-7.03.23-.77.36-1.58.66-2.31.41-1,.48-2.04.61-3.08.31-2.55-.3-4.92-1.48-7.17-.31-.59-.75-1.01-1.28-1.39-2.15-1.51-4.49-2.03-7.05-1.43-1.58.37-2.99,1.01-4,2.4-1.55,2.16-1.94,4.61-2,7.12Zm9.04-41.04c2.81-.17,5.37-1.08,7.68-2.76,1.54-1.12,2.63-2.61,3.71-4.13.16-.23.02-.35-.09-.51-1.74-2.62-3.87-4.9-6.23-6.95-3.28-2.84-7.78-3.17-11.24-.33-1.02.84-2.02,1.72-2.99,2.62-1.41,1.31-2.51,2.89-3.5,4.53-.17.28-.28.55,0,.87.57.64,1.09,1.34,1.66,1.97,2.94,3.26,6.64,4.76,11.01,4.69Zm15.63,8.61c-.1-1.97-.14-4.28-.53-6.56-.42-2.47-1.41-4.74-2.45-6.99-.38-.82-.41-.84-.97-.13-2.17,2.76-5,4.52-8.27,5.66-.67.23-1.38.35-2.05.56-.59.18-.63.41-.2.8,3.99,3.61,7.89,7.32,11.71,11.11.45.45.93.88,1.4,1.3.2.18.45.43.7.34.3-.1.33-.46.35-.76.13-1.67.3-3.33.3-5.34Zm-32.61-.24c-.07,2.02.17,3.84.43,5.67.04.32.1.68.52.3,2-1.82,4-3.64,5.98-5.47,1.48-1.37,2.94-2.76,4.42-4.13,1.01-.93,2.06-1.82,3.08-2.74.26-.24.69-.61-.02-.77-1.94-.43-3.72-1.23-5.47-2.12-1.93-.98-3.58-2.32-4.79-4.15-.15-.23-.18-.64-.57-.59-.32.05-.42.38-.54.65-.67,1.47-1.16,3.02-1.68,4.55-.99,2.89-1.49,5.89-1.38,8.8Zm24.88,53.06c1.88.21,3.8-.56,5.53-1.97.46-.37.42-.62.1-1.02-1.95-2.46-3.34-5.26-4.73-8.05-.59-1.19-.83-2.5-.99-3.81-.03-.26-.07-.54-.32-.61-.26-.07-.33.24-.41.43-.19.43-.36.86-.55,1.29-.81,1.88-1.73,3.68-3.27,5.1-1.01.93-2.12,1.66-3.36,2.21-.4.18-.61.34-.21.79.52.59.93,1.27,1.43,1.87,1.69,2,3.62,3.6,6.78,3.76Zm-18.81-.07c2.07.08,3.77-.55,5.34-1.68,1.3-.94,2.24-2.19,3.22-3.42.67-.86.68-.96-.28-1.5-.24-.13-.49-.24-.72-.36-1.44-.76-2.66-1.77-3.52-3.17-.83-1.34-1.66-2.67-2.18-4.17-.07-.22-.11-.55-.42-.52-.26.03-.22.33-.28.54-.22.88-.37,1.79-.71,2.62-1.41,3.45-3.4,6.52-6.1,9.11-.24.23-.39.4-.03.62,1.81,1.06,3.61,2.11,5.7,1.94Zm-4.84-43.89c1.72,6.43,4,12.7,5.95,19.07.24-.36.35-.71.49-1.04.75-1.77,1.86-3.24,3.57-4.16.99-.53,2.09-.82,3.19-1.07.25-.06.57-.11.66-.41.09-.31-.18-.49-.39-.65-1.99-1.57-3.8-3.34-5.68-5.04-2.42-2.19-4.97-4.25-7.27-6.57-.1-.1-.18-.25-.52-.13Zm30.33-.77c-.39-.03-.6.19-.8.4-1.95,2.09-3.98,4.09-6.11,5.98-2.15,1.91-4.29,3.84-6.42,5.77-.33.3-1.05.43-.96.9.1.53.8.56,1.29.7,1.85.53,3.44,1.42,4.54,3.06.48.72.89,1.47,1.23,2.26.06.15.12.37.32.35.25-.02.24-.27.27-.46.05-.34.01-.67.13-1.02.57-1.62,1.33-3.17,1.93-4.78,1.28-3.42,2.79-6.75,3.72-10.29.25-.96.73-1.85.85-2.87Zm9.04-17.94c-3.1,0-5.05.51-6.4,2.41-.86,1.21-.7,2.72.42,3.75,2.05,1.89,4.49,2.18,7.08,1.63,2.25-.48,3.97-1.83,5.43-3.56.42-.5.41-.86-.1-1.29-2.13-1.79-4.47-3.01-6.42-2.94Zm-47.21.02c-3.37-.08-5.77,1.34-8.01,3.13-.39.31-.38.63-.04,1,2.47,2.7,5.46,4.12,9.17,3.72,1.42-.15,2.7-.68,3.69-1.79.91-1.02,1.24-2.78-.06-4.03-1.45-1.39-3.1-2.12-4.75-2.03Zm7.23,46.63c2.16.08,3.88-.71,5.11-2.52.24-.36.35-.75.35-1.18-.01-1.57-1.53-3.33-3.28-3.72-2.35-.52-4.58-.05-6.75.89-1.13.49-2.22,1.05-3.01,2.05-.28.36-.27.59.04.94,2.02,2.26,4.52,3.47,7.54,3.54Zm30.7,0c.61-.04,1.22.02,1.83-.1,2.36-.45,4.14-1.8,5.67-3.57.25-.29.14-.44-.1-.66-2.18-1.9-4.72-2.95-7.59-3.22-2.64-.25-4.66.94-5.42,3.19-.14.42-.18.83.03,1.22.47.87,1.05,1.65,1.86,2.25,1.12.83,2.4.91,3.72.88Z" />
    </g>
    <text className="logo-txt-1" transform="translate(0 167.87)">HOUSE OF KARNNIKARAA</text>
    <text className="logo-txt-2" transform="translate(167.89 230.19)">925 SILVER JEWELLERY</text>
    <line className="logo-line" x1="604.09" y1="221.96" x2="740.98" y2="221.96"/>
    <line className="logo-line" x1="11.21" y1="221.96" x2="148.09" y2="221.96"/>
  </svg>
);

const Footer = ({ setView, setIsBookingOpen }) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }
    try {
      await subscribeNewsletter(email);
      setIsSubmitted(true);
      setEmail('');
      setTimeout(() => {
        setIsSubmitted(false);
      }, 2500);
    } catch (err) {
      console.error(err);
      // Fallback local support
      setIsSubmitted(true);
      setEmail('');
      setTimeout(() => {
        setIsSubmitted(false);
      }, 2500);
    }
  };

  return (
    <footer className="text-[#F5E6D8]" style={{ backgroundColor: '#584738', backgroundImage: 'url("/Frame 3.png")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 xl:px-14 py-8 md:py-12 xl:py-16">

        {/* ── 5-COLUMN GRID ON DESKTOP, BALANCED 2-TIER 6-COL GRID ON TABLET / IPAD, 2-COL ON MOBILE ── */}
        <div className="grid grid-cols-2 md:grid-cols-6 xl:grid-cols-[1.3fr_1fr_1fr_1.1fr_1.2fr] gap-y-8 md:gap-y-10 xl:gap-y-0 gap-x-6 md:gap-x-8 xl:gap-x-8 items-start">

          {/* Col 1 — Brand */}
          <div className="col-span-2 md:col-span-3 xl:col-span-1 md:order-1 xl:order-1 flex flex-col justify-start">
            <div 
              onClick={() => setView && setView('home')}
              className="cursor-pointer self-start text-[#F5E6D8] opacity-90"
            >
              <Logo />
            </div>
          </div>

          {/* Col 2 — OUR WORLD */}
          <div className="col-span-1 md:col-span-2 xl:col-span-1 md:order-3 xl:order-2 flex flex-col">
            <h4 className="text-[12px] font-sans uppercase tracking-[0.22em] mb-5 text-[#F5E6D8] font-semibold">
              Our World
            </h4>
            <div className="flex flex-col gap-3 text-[13px] font-normal text-[#F5E6D8]/70 font-sans">
              <button
                onClick={() => {
                  try {
                    sessionStorage.setItem('hok_skip_collection_hero', 'true');
                  } catch (e) {}
                  if (setView) setView('collections');
                  window.dispatchEvent(new CustomEvent('hok_scroll_to_collection_content'));
                  setTimeout(() => {
                    const el = document.getElementById('collections-content');
                    if (el) {
                      const targetTop = el.getBoundingClientRect().top + window.pageYOffset;
                      window.scrollTo({ top: Math.round(targetTop), behavior: 'smooth' });
                    }
                  }, 80);
                }}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Collections
              </button>
              <button
                onClick={() => {
                  if (window.setHokCategory) window.setHokCategory('All');
                  if (setView) setView('marketplace');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Jewellery
              </button>
              <button
                onClick={() => {
                  if (setIsBookingOpen) setIsBookingOpen(true);
                  window.dispatchEvent(new CustomEvent('hok_open_booking'));
                }}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Bespoke
              </button>
              <button
                onClick={() => {
                  if (setView) setView('home');
                  setTimeout(() => {
                    const el = document.getElementById('our-story');
                    if (el) {
                      el.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }, 120);
                }}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                The house
              </button>
              <button
                onClick={() => {
                  if (setView) setView('journal');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Care Guide
              </button>
            </div>
          </div>

          {/* Col 3 — Policies */}
          <div className="col-span-1 md:col-span-2 xl:col-span-1 md:order-4 xl:order-3 flex flex-col">
            <h4 className="text-[12px] font-sans uppercase tracking-[0.22em] mb-5 text-[#F5E6D8] font-semibold">
              Policies
            </h4>
            <div className="flex flex-col gap-3 text-[13px] font-normal text-[#F5E6D8]/70 font-sans">
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('hok_legal_view', { detail: { title: 'Shipping Policy' } }))}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Shipping Policy
              </button>
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('hok_legal_view', { detail: { title: 'Exchange, Return & Refund Policy' } }))}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Exchange &amp; Return Policy
              </button>
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('hok_legal_view', { detail: { title: 'Terms & Conditions' } }))}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Terms &amp; Conditions
              </button>
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('hok_legal_view', { detail: { title: 'Privacy Policy' } }))}
                className="text-left hover:text-[#F5E6D8] transition-colors focus:outline-none"
              >
                Privacy Policy
              </button>
            </div>
          </div>

          {/* Col 4 — STAY CONNECTED */}
          <div className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1 md:order-5 xl:order-4 flex flex-col">
            <h4 className="text-[12px] font-sans uppercase tracking-[0.22em] mb-4 sm:mb-5 text-[#F5E6D8] font-semibold">
              Stay Connected
            </h4>
            <div className="flex flex-col gap-1.5 text-[13px] font-normal text-[#F5E6D8]/70 font-sans">
              <p>+91 91662 09215</p>
              <p className="whitespace-nowrap text-[clamp(9.5px,2.75vw,13px)] md:text-[13px] tracking-tight sm:tracking-normal">houseofkarnnikaraa@gmail.com</p>
              <div className="mt-3 sm:mt-4">
                <p className="leading-[1.8]">
                  L2A Golden Palace<br />
                  Krishna marg , C scheme<br />
                  Jaipur
                </p>
              </div>
            </div>
          </div>

          {/* Col 5 — NEWSLETTER */}
          <div className="col-span-2 md:col-span-3 xl:col-span-1 md:order-2 xl:order-5 flex flex-col md:max-w-sm md:ml-auto xl:ml-0 xl:max-w-none w-full">
            <h4 className="text-[12px] font-sans uppercase tracking-[0.22em] mb-3 sm:mb-5 text-[#F5E6D8] font-semibold">
              Newsletter
            </h4>
            <p className="text-[13px] font-normal text-[#F5E6D8]/70 font-sans leading-[1.75] mb-4 sm:mb-5">
              Stay updated with us for the new collections.
            </p>
            <form onSubmit={handleSubscribe} className="flex border border-[#F5E6D8]/30">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 min-w-0 bg-transparent text-[12px] font-sans font-normal text-[#F5E6D8] placeholder-[#F5E6D8]/40 px-3 py-2.5 focus:outline-none"
              />
              <button
                type="submit"
                className="px-3.5 py-2.5 text-[#F5E6D8]/70 hover:text-[#F5E6D8] transition-colors focus:outline-none border-l border-[#F5E6D8]/30 text-base font-medium flex items-center justify-center min-w-[42px]"
                aria-label="Subscribe"
              >
                {isSubmitted ? (
                  <svg className="w-4 h-4 text-green-400 animate-[scaleIn_0.25s_ease-out]" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                ) : (
                  "→"
                )}
              </button>
            </form>
            <style>{`
              @keyframes scaleIn {
                0% { transform: scale(0); opacity: 0; }
                100% { transform: scale(1); opacity: 1; }
              }
            `}</style>
          </div>

        </div>

        {/* ── BOTTOM DIVIDER ── */}
        <div className="w-full h-px bg-[#F5E6D8]/20 mt-12 mb-6" />

        {/* ── COPYRIGHT ── */}
        <p className="text-[11px] tracking-[0.08em] text-[#F5E6D8]/70 font-normal text-center font-sans">
          © 2026, House of Karnnikaraa. All Rights Reserved
        </p>

      </div>
    </footer>
  );
};

export default Footer;
